// This is probably a brainflex specific class and needs moving to the brainflex folder
import React, { createContext, useContext } from "react";
import ServiceClient from "./ServiceClient";

const ServiceClientContext = createContext<ServiceClient | null>(null);

export const ServiceClientProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  //const serviceClient = new ServiceClient();
  const serviceClient = new ServiceClient();
  return (
    <ServiceClientContext.Provider value={serviceClient}>
      {children}
    </ServiceClientContext.Provider>
  );
};

export const useServiceClient = () => {
  const context = useContext(ServiceClientContext);
  if (!context) 
    throw new Error("useServiceClient must be used within a ServiceClientProvider");
  return context;
};
